import React from 'react'
import Link from 'next/link'
import { CustomButtonContainer, CustomButtonTree } from './button.styles'

const CustomButton = ({ label, children, href, external, onClick, secondary = false, ...props }) => {
  const content = children || label
  const shared = { onClick, $secondary: secondary, ...props }
  if (!href) return <CustomButtonContainer type="button" {...shared}>{content}</CustomButtonContainer>
  if (external) return <CustomButtonContainer as="a" href={href} target="_blank" rel="noopener noreferrer" {...shared}>{content}</CustomButtonContainer>
  return <Link href={href} passHref legacyBehavior><CustomButtonContainer as="a" {...shared}>{content}</CustomButtonContainer></Link>
}
const ButtonNoLink = ({ label, children, ...props }) => <CustomButtonContainer type="button" {...props}>{children || label}</CustomButtonContainer>
const ButtonNoLinkTree = ({ label, children, ...props }) => <CustomButtonTree type="button" {...props}>{children || label}</CustomButtonTree>
export { CustomButton, ButtonNoLink, ButtonNoLinkTree }
